import { t } from "../lib/i18n";
import React from 'react';
import Tooltip from './Tooltip';

export interface SummaryReport {
  total_properties: number;
  total_tenants: number;
  total_documents: number;
  average_monthly_rent: number;
}

interface SummaryReportSectionProps {
  summary: SummaryReport | null;
  loading: boolean;
  error: string | null;
}

const SummaryReportSection: React.FC<SummaryReportSectionProps> = ({ summary, loading, error }) => {

  if (loading) {
    return <div className="p-4">{t("summaryReportSection.k1")}</div>;
  }

  if (error) {
    return <div className="p-4 text-danger">{t("summaryReportSection.k2")} {error}</div>;
  }

  return (
    <div className="bg-bg-primary"> {/* Removed container mx-auto p-4 min-h-screen */}
      <div className="flex items-center mb-4">
        <h2 className="text-2xl font-bold text-text-secondary">{t("summaryReportSection.k3")}</h2>
        <Tooltip text="This section provides a high-level summary report of your entire portfolio. It includes key metrics such as the total number of properties, tenants, and documents, as well as the average monthly rent across all your properties." />
      </div>



      {summary ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary">
            <h3 className="text-lg font-semibold mb-2 text-text-secondary">{t("summaryReportSection.k4")}</h3>
            <p className="text-2xl font-bold text-text-primary">{summary.total_properties}</p>
          </div>
          <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary">
            <h3 className="text-lg font-semibold mb-2 text-text-secondary">{t("summaryReportSection.k5")}</h3>
            <p className="text-2xl font-bold text-text-primary">{summary.total_tenants}</p>
          </div>
          <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary">
            <h3 className="text-lg font-semibold mb-2 text-text-secondary">{t("summaryReportSection.k6")}</h3>
            <p className="text-2xl font-bold text-text-primary">{summary.total_documents}</p>
          </div>
          <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary">
            <h3 className="text-lg font-semibold mb-2 text-text-secondary">{t("summaryReportSection.k7")}</h3>
            <p className="text-2xl font-bold text-text-primary">${summary.average_monthly_rent?.toLocaleString() || 'N/A'}</p>
          </div>
        </div>
      ) : (
        <p className="text-text-secondary">{t("summaryReportSection.k1")}</p>
      )}
    </div>
  );
};

export default SummaryReportSection;
